import React from 'react';
import './Testimonial.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/testimonial/1.png';
import imgTwo from '../../assets/testimonial/2.png';
import imgThree from '../../assets/testimonial/3.png';
import TestimoniCard from '../../components/TestimoniCard/TestimoniCard';
import { AiFillStar } from "react-icons/ai";
import Slider from "react-slick";

const Testimonial = () => {

  // 5 golden stars
  const fullStars = Array(5).fill(<AiFillStar style={{ color: '#f6b100' }} />);

  const testimonials = [
    {
      img: imgOne,
      name: 'Dev Kumar Sahni',
      description:
        'I am very happy the way Dr. Tanwar treated my case when other dentists couldn’t do properly. He corrected the mistake done by another dentist and saved my tooth. Highly recommended for RCT or specialist treatment.',
      ratings: fullStars
    },
    {
      img: imgTwo,
      name: 'TALVINDER KOUR',
      description:
        'Highly recommend Dr. Tanwar. Best in his service. The treatment was completely painless and done with great care. Excellent dental experience overall.',
      ratings: fullStars
    },
    {
      img: imgThree,
      name: 'Manoj Kumar',
      description:
        'It was a really nice experience getting treatment from Dr. Tanwar. He is very experienced and humble. He treated my difficult tooth case efficiently and painlessly.',
      ratings: fullStars
    },
    {
      img: imgOne,
      name: 'Ishanvi',
      description:
        'Excellent doctor for root canal treatment and braces. My sister got her braces done here and within 6 months her teeth were aligned beautifully. Thank you Dr. Tanwar!',
      ratings: fullStars
    },
    {
      img: imgTwo,
      name: 'Tushar Aggarwal',
      description:
        'Dr. Tanwar Dental Clinic is truly one of the best clinics I’ve ever visited. Both doctors are highly skilled, caring, and dedicated to their patients. Unlike many clinics, they give proper time and attention.',
      ratings: fullStars
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,             // ✅ auto-scroll enabled
    autoplaySpeed: 1000,        // ✅ scroll every 1 second
    cssEase: "linear",          // smooth scroll
    pauseOnHover: true,         // stop when user hovers
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className='testimonail-section section-bg section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <SectionTitle
              subTitle="TESTIMONIAL"
              title="What our patients say about Dr. Tanwar Dental Clinic"
            />
          </div>
          <div className="col-lg-6">
            <p className="pt-5">Real feedback from our happy patients sharing their dental experiences at Dr. Tanwar Dental Clinic.</p>
          </div>
        </div>

        <Slider {...settings} className="testimoni-slider">
          {testimonials.map((testimonial, index) => (
            <TestimoniCard key={index} testimonail={testimonial} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
